import { Component, OnInit } from '@angular/core';
import {Router} from "@angular/router";

@Component({
  selector: 'app-innovation-and-enterpreneurship',
  templateUrl: './innovation-and-enterpreneurship.component.html',
  styleUrls: ['./innovation-and-enterpreneurship.component.scss']
})
export class InnovationAndEnterpreneurshipComponent implements OnInit {
    pageTitle = '';
    activeIndex: number | null = null;

  constructor(
      private router: Router,
  ) { }

  ngOnInit(): void {
      this.pageTitle = 'Innovation and Entrepreneurship';
  }

    goTo(url: string) {
        this.router.navigateByUrl(url);
    }
}
